import React from "react";
import { useSelector } from "react-redux";

// Components
import DoctorCard from "./DoctorCard";
import Link from "components/common/Link";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Text from "components/common/Text";
import DotLoader from "components/common/DotLoader";
import BreadCrumbs from "components/common/BreadCrumbs";
import Banner from "./Banner";
import Faq from "./Faq";

// Libs
import Translation from "libs/Translation";

const Doctors = ({
  mobileView,
  title,
  doctors,
  page,
  count,
  loading,
  lastBreadCrumb,
  faqList,
  params,
  pageURL,
}) => {
  const { webConfig } = useSelector((state) => state.core);

  const breadCrumbsList = [
    {
      key: 0,
      label: Translation.t("title.default"),
      to: "/",
      params: webConfig.lang !== "fa" ? { lang: webConfig.lang } : {},
    },
    {
      key: 1,
      label: Translation.t("title.doctors"),
      to: "/explore/doctors",
      params: webConfig.lang !== "fa" ? { lang: webConfig.lang } : {},
    },
  ];
  if (lastBreadCrumb) {
    breadCrumbsList.push({
      key: 2,
      label: lastBreadCrumb,
      to: pageURL,
      params: params,
    });
  }

  return (
    <div className="doctors-wrapper">
      <div className="bread-crumbs">
        <BreadCrumbs list={breadCrumbsList} />
      </div>
      <Text tag="h1" className="page-title">
        {title}
      </Text>
      <div className="container">
        {doctors?.length > 0 ? (
          <>
            {loading ? (
              <div className="loading">
                <DotLoader size={20} color="gray" />
              </div>
            ) : (
              <>
                <DoctorCard
                  doctor={doctors[0]?.profiles}
                  specialty={doctors[0]?.specialtyDetails}
                  webConfig={webConfig}
                />
                <Banner webConfig={webConfig} mobileView={mobileView} />

                {doctors?.slice(1).map((d) => (
                  <DoctorCard
                    doctor={d?.profiles}
                    specialty={d?.specialtyDetails}
                    webConfig={webConfig}
                  />
                ))}
              </>
            )}
          </>
        ) : (
          <>
            {loading ? (
              <div className="loading">
                <DotLoader size={20} color="gray" />
              </div>
            ) : (
              <Text tag="p" className="not-found">
                {Translation.t("text.no-item-found")}
              </Text>
            )}
          </>
        )}
      </div>
      {doctors?.length > 0 && !loading && count > 1 && (
        <Pagination
          page={page}
          count={count}
          showFirstButton
          showLastButton
          className="pagination"
          renderItem={(item) => (
            <PaginationItem
              component={Link}
              to={pageURL}
              params={item.page !== 1 ? { ...params, page: item.page } : params}
              shape="rounded"
              {...item}
            />
          )}
        />
      )}

      {faqList?.length ? <Faq faqList={faqList} /> : null}
    </div>
  );
};

export default Doctors;
